export const apiLinks = {
    login: '/users/auth/login',
    findByBarcode: '/products/findbybarcode',
    findProductById: '/products',
  };